function answer_init(item) {
    let user_answer = item.user_answer.split(",");
    item.option = item.option.map((e) => {
        // 未初始化过
        if (typeof (e.user_status) == 'undefined') {

            let b = false;
            for (let ee of user_answer) {
                if (ee == e.key) {
                    b = true;
                }
            }
            e.user_status = b ? 2 : 1;
            e.status = 0;
        }
        return e;
    });
}
function blanks2(item) {
    if (Array.isArray(item.blanks_answer)) {
        return item;
    }

    item.blanks_answer = item.blanks_answer.split("||");
    let i = 0;
    item.hidden_title = item.title.replace(/%s/gi, () => {
        return `<span style="border-bottom: 1px dashed #030000;color:#fff;">${item.blanks_answer[i++]
            }</span>`;
    });
    // item.hidden_title = `${item.s_num}.` + item.hidden_title
    i = 0;
    item.show_title = item.title.replace(/%s/gi, () => {
        return `<span style="border-bottom: 1px dashed #030000;color:#4578E9;font-weight: bold;">${item.blanks_answer[i++]
            }</span>`;
    });
    // item.show_title = `${item.s_num}.` + item.show_title
    item.is_blanks = item.user_answer ? 1 : 0;
    return item;
}
function type_text(item) {
    if (item.type == 1) {
        item.type_text = "单选题";
    }
    if (item.type == 2) {
        item.type_text = "多选题";
    }
    if (item.type == 3) {
        item.type_text = "判断题";
    }
    if (item.type == 4) {
        item.type_text = "填空题";
    }
    if (item.type == 5) {
        item.type_text = "名词解释";
    }
    if (item.type == 6) {
        item.type_text = "问答题";
    }
}
function str_html(s) {
    if (!s) {
        return "";
    }
    s = s.replace(/（.+?）/gi, (e1, e2) => {
        if (/P\d+/.test(e1)) {
            return `<span style="color:#AF9D64;">${e1}</span>`;
        } else {
            return `<b>${e1}</b>`;
        }

    });
    return s;
}
const ico_img = require("../image/icon_daan_default.png")

function str_html_img(s, key) {
    if (!s) {
        return "";
    }
    let i = 0;
    s = s.replace(/<img>/gi, (e1, e2) => {
        return `<img style="width:16px;height:13px;margin-right:2px;" title="${key}" id="${i++}" src="${ico_img}" />`;
    });
    return s;
}

function setDifficulty(item) {

    let x = (item.wrong_count / (item.right_count + item.wrong_count) * 10);
    x = Math.ceil(x)
    return x;
}

function blanks(item) {
    if (!item.blanks_answer) {
        return
    }
    item.blanks_answer = item.blanks_answer.split("||");
    let i = 0;
    item.hidden_title = item.title.replace(/%s/gi, () => {
        return `<span style="border-bottom: 1px dashed #030000;color:#fff;">${item.blanks_answer[i++]
            }</span>`;
    });
    // item.hidden_title = `${item.s_num}.` + item.hidden_title
    item.hidden_title = item.hidden_title.replace(/&&/gi, "<br/>");
    i = 0;
    item.show_title = item.title.replace(/%s/gi, () => {
        return `<span style="border-bottom: 1px dashed #030000;color:#333;font-weight: bold;">${item.blanks_answer[i++]
            }</span>`;
    });
    // item.show_title = `${item.s_num}.` + item.show_title
    item.show_title = item.show_title.replace(/&&/gi, "<br/>");
}
function tips(item) {
    if (item.tips) {
        item.number = item.tips
        return
    }
    if (item.page_num) {
        item.number = '[' + item.page_num + ']'
        return
    }
    if (item.number) {
        item.number = '[' + item.number + ']'
        return
    }
}
function initData(item) {
    if (item.is_initData == 1) {
        return item
    }
    item.is_initData = 1

    if (item.is_init) {
        return item
    }
    if (item.type == 20) {
        item.type = 4
    }
    item.is_init = true;
    if (typeof (item.is_sub) == "undefined") {
        item.is_sub = 0;
    }
    item.is_record = 0;

    answer_init(item)
    type_text(item)
    item.noteList = [];
    item.noteUpdate = false;
    item.tab_list = [];


    // if (typeof (item.number) == "undefined" || !item.number) {
    //     // item.number = `${item.type_text}题`;
    //     // tips(item)
    // }


    if (item.type == 4) {
        blanks(item);
        item.is_blanks = 0;
    }
    if (item.type == 5 || item.type == 6) {
        item.is_blanks = 0;
    }

    {
        if (item.materials_title) {
            item.materials_title = item.materials_title.replace(/&&/gi, "<br/>");
        }

        item.title = item.title.replace(/&&/gi, "<br/>");
    }
    // item.materials_id=88
    return item
}

function SetdataInit(item) {
    if (item.type == 20) {
        item.type = 4
    }
    item.select_answer = [];
    item.restore = item.restoren;

    // b
    item.syllabus = str_html(item.syllabus);
    item.recovery = str_html(item.recovery);
    item.restore = str_html(item.restore);
    item.restoren = str_html(item.restoren);
    item.explain = str_html(item.explain);
    item.explainn = str_html(item.explainn);

    // img
    item.syllabus = str_html_img(item.syllabus, "syllabus");
    item.recovery = str_html_img(item.recovery, "recovery");
    item.restore = str_html_img(item.restore, "restore");
    item.restoren = str_html_img(item.restoren, "restoren");
    item.explain = str_html_img(item.explain, "explain");
    item.explainn = str_html_img(item.explainn, "explainn");

    item.title_img = str_html_img(item.title_img, "title_img");

    // item.difficulty = setDifficulty(item);
    return item
}
const topic = {
    namespaced: true,
    state: () => {
        return {
            tiList: [],
            questionList: [],
            oneTiList: {},
            question_type: {}
        }
    },
    getters: {
        // 切换模式的时候会从源数据复制新的，否则数据不会刷新
        gettiList: (state) => {
            if (state.tiList.length == 0) {
                let tiList = sessionStorage.getItem('tiList')
                return JSON.parse(tiList)
            } else {
                return state.tiList
            }
        },
        getQuestion_type: (state) => {
            let question_type = sessionStorage.getItem('question_type')
            if (state.question_type.length == 0) {
                return JSON.parse(question_type)
            } else {
                return state.question_type;
            }
        },
        getQuestionList: (state) => {
            return state.questionList;
        },
        getOneTi: (state) => (question_id) => {
            if (Object.keys(state.oneTiList).length == 0) {
                let OneTiList = sessionStorage.getItem('OneTiList')
                if (OneTiList) {
                    state.oneTiList = JSON.parse(OneTiList)
                } else {
                    // alert('缓存数据丢失，请返回题库')
                }
            }
            return [state.oneTiList[question_id]]
            for (let e of state.oneTiList) {
                if (e.question_id == question_id) {
                    return [e]
                }
            }
            // alert('缓存数据丢失，请返回题库')
        },
    },
    mutations: {
        remove(state, question_id) {
            list_Remove(state.tiList, (e) => {
                return e.question_id == question_id;
            });
            list_Remove(state.questionList, (e) => {
                return e.question_id == question_id;
            });
        },
        // 合并用户提交的答案
        saveRecord(state, list) {
            if (list.length > 0) {
                sessionStorage.setItem('userSubdata', 1)
            }
            state.questionList.map(item => {
                list.map(e => {
                    if (e.question_id == item.question_id) {
                        // 合并数据
                        item.user_answer = e.user_answer;
                    }
                })
            })
        },
        // 合并操作记录
        saveUserSub(state, list) {
            list.map(e => {
                state.questionList.map(item => {
                    if (e.question_id == item.question_id) {
                        // 合并数据
                        item.is_note = e.is_note;
                        item.is_coll = e.is_coll;
                        item.is_comment = e.is_comment;
                    }
                })
            })
        },
        // 添加笔记状态
        add_note(state, question_id) {
            for (let e of state.tiList) {
                if (e.question_id == question_id) {
                    e.noteUpdate = true;
                    e.is_note = 1
                }
            }
        },
        // 修改评论
        del_comment(state, res) {
            for (let e of state.tiList) {
                if (e.question_id == res.question_id) {
                    e.is_comment = res.del ? 0 : 1
                }
            }
        },
        // 设置时复制并初始化
        settiList: (state, data) => {
            state.tiList = JSON.parse(JSON.stringify(data)).map(initData)
            sessionStorage.setItem('tiList', JSON.stringify(state.tiList))
        },
        // question_type
        setQuestion_type: (state, data) => {
            state.question_type = data
            sessionStorage.setItem('question_type', JSON.stringify(data))
        },
        settiList2: (state, data) => {
            state.tiList = JSON.parse(JSON.stringify(data)).map(initData)
            sessionStorage.setItem('tiList', JSON.stringify(state.tiList))
        },
        setQuestionList: (state, data) => {
            state.questionList = data.map(SetdataInit)
        },
        setOneTi: (state, data) => {
            state.oneTiList[data.question_id] = initData(JSON.parse(JSON.stringify(data)))
            console.log(state.oneTiList[data.question_id])
            sessionStorage.setItem('OneTiList', JSON.stringify(state.oneTiList))

        },
    }
}

export default topic


// WEBPACK FOOTER //
// ./src/store/topic.js